import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class PearlHarborGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_NUMBER_WAYS_WON = "NumbersWaysWon";
    static BITMAP_FONT_NUMBER_WAYS = "NumbersWays";
    static BITMAP_FONT_MULTIPLIER = "NumbersMult";
    static BITMAP_FONT_COIN_MULTIPLIER = "NumbersCoinMult";
    static BITMAP_FONT_FS_PASSIVE = "NumberFSPassive";
    static BITMAP_FONT_FS_ACTIVE = "NumbersFSActive";
    static BOOST_BUTTON_ON_1 = "enhancedBetButtonOn1";
    static BOOST_BUTTON_ON_2 = "enhancedBetButtonOn2";
    static BOOST_BUTTON_OFF = "enhancedBetButtonOff";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],
        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_NUMBER_WAYS, "fonts/bitmapfonts/NumbersWays.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_NUMBER_WAYS_WON, "fonts/bitmapfonts/NumbersWaysWon.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/NumbersMult.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_COIN_MULTIPLIER, "fonts/bitmapfonts/NumbersCoinMult.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_FS_PASSIVE, "fonts/bitmapfonts/NumberFSPassive.fnt"),
                    new BitmapFontAsset(PearlHarborGameAssets.BITMAP_FONT_FS_ACTIVE, "fonts/bitmapfonts/NumbersFSActive.fnt"),
                ]
            },
            {
                name: "main",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json")
                    //new TextureAsset("main5", "sheets/main/main5.json")
                ],
                animations: {
                    "multBackground": "enhancedBetBetMeter/bombMultiplierMeter",
                    "enhancedBetButtonOff":"enhancedBetBetMeter/enhancedSwitchOff",
                    "enhancedBetButtonOn1":"enhancedBetBetMeter/enhancedSwitchOn1",
                    "enhancedBetButtonOn2":"enhancedBetBetMeter/enhancedSwitchOn2",
                    "scatterCounter1On":"enhancedBetBetMeter/scatterCounter1On",
                    "scatterCounter2On":"enhancedBetBetMeter/scatterCounter1OnSFS",
                    "scatterCounter1":"enhancedBetBetMeter/scatterCounter1",
                    "scatterCounter2":"enhancedBetBetMeter/scatterCounter2",
                    "enhancedBetButtonHighLight":"enhancedBetBetMeter/LightWhenEnhancedBet2On",

                    "banzai_frame":"banzai/banzai_frame",
                    "scatterCounterMultiplierOff":"enhancedBetBetMeter/accumulatedScatterMultiplieMeterOff",
                    "scatterCounterMultiplierOn":"enhancedBetBetMeter/accumulatedScatterMultiplieMeterOn",
                    "scatterMultiplierFSIntro":"enhancedBetBetMeter/ScatterMultiplier",
                    "FS_METER_SPIN_TEXTURE":"cocpitDashboardMeters/spinningMeter",
                    "FS_METER_IDLE_TEXTURE":"cocpitDashboardMeters/meterBaseNeedle",
                    "FS_METER_WIN_TEXTURE":"cocpitDashboardMeters/meterExplosionFares",
                    "SFS_METER_SPIN_TEXTURE":"cocpitDashboardMeters/1meterBase",
                    "SFS_METER_IDLE_TEXTURE":"cocpitDashboardMeters/1meterBase",
                    "SFS_METER_WIN_TEXTURE":"cocpitDashboardMeters/meterExplosion",
                    "toraSpinsAttention":"cocpitDashboardMeters/toraSpinsAttention",
                    "dashBoardPiceForToraSpins":"cocpitDashboardMeters/dashBoardPiceForToraSpins",
                    "bonusMeters":"metersBetweenMachineGuns/dashBoardBetwenMachineguns",
                    "bonusMetersSpinsLeft":"metersBetweenMachineGuns/spinLeftCovers",
                    "columnHitCover":"metersBetweenMachineGuns/columnHitCover",
                    "rowCounterCower":"metersBetweenMachineGuns/rowCounterCower",
                    "dogFightPart":"metersBetweenMachineGuns/dogFightPart",
                    "bonusMetersCover":"metersBetweenMachineGuns/cover",
                    "allBullets":"metersBetweenMachineGuns/backgroundForMeters",
                    "kamikazeTop":"kamikazemeter/kamikazemeter",
                    "kamikazeMeter":"kamikazemeter/displayIndikator",
                    "kamikazeText":"kamikazemeter/kamikazeText",
                    "fsIntroDogfight":"FSIntro/dogfight",
                    "fsIntroTora":"FSIntro/toraText",
                }
            },
            {
                name: "mainJpeg",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json")
                    //new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    //new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    //new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    //new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    //new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    //new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    //new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    //new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                    //new TextureAsset("mainJpeg16", "sheets/mainJpeg/mainJpeg16.json"),
                    //new TextureAsset("mainJpeg17", "sheets/mainJpeg/mainJpeg17.json"),
                    //new TextureAsset("mainJpeg18", "sheets/mainJpeg/mainJpeg18.json")
                ],
                animations: {
                    "multiplierFlyShine": "mult_dot/mult_dot_00",
                    "tiny": "WinHL_Tiny/WinHL_Tiny_",
                    "small": "WinHL_Small/WinHL_Small_",
                    "medium": "WinHL_Mid/WinHL_Mid_",
                    "large": "WinHL_Large/WinHL_Large_",
                    "sideCollector": "freespin/RSC_unlock/RSC_unlock_",
                    "multParitcle": "freespin/mult_particle/mult_particle_",
                    "normalSpinsMode": "FS_intro/Title_nomal",
                    "resetSpinsMode": "FS_intro/Title_reset",

                    // lucky draw
                    "luckyDrawTitle": "FS_intro/FS_intro_title",
                    "luckyDrawGlow": "FS_intro/Mode_glow",
                    "luckyDrawStdFS": "luckyDrawFeature/stdFS",
                    "luckyDrawCoolFS": "luckyDrawFeature/coolFS",
                    "luckyDrawSuperFS": "luckyDrawFeature/superFS",
                    "luckyDrawFireFrameBlast": "luckyDrawFeature/fireFrameBlast/fire_frame_start_",

                    // #399
                    "strongMultiAnim": "freespin/refresh/refresh_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "BN/BN":"S/S",
                    "BN_H/BN_H":"S/S_h",

                    "M1_H/M1_H":"M1/M1_h",
                    "M2_H/M2_H":"M2/M2_h",
                    "M3_H/M3_H":"M3/M3_h",
                    "M4_H/M4_H":"M4/M4_h",
                    "L1_H/L1_H":"L1/L1_h",
                    "L2_H/L2_H":"L2/L2_h",
                    "L3_H/L3_H":"L3/L3_h",
                    "L4_H/L4_H":"L4/L4_h",
                    "L5_H/L5_H":"L5/L5_h",
                    "X_BOMB_H/X_BOMB_H":"X_BOMB/X_BOMB_h",
                    "X_SPLIT_H/X_SPLIT_H":"XS/XS_h",
                    "X_SPLIT_SPENT_H/X_SPLIT_SPENT_H":"XS/X_SPLIT_SPENT_H",
                    "TARGET_SPENT_H/TARGET_SPENT_H":"TARGET/TARGET_SPENT_H",
                    "TARGET_H/TARGET_H":"TARGET/TARGET_H",

                    "X_SPLIT/X_SPLIT":"XS/XS",
                    "X_SPLIT_SPENT/X_SPLIT_SPENT":"XS/X_SPLIT_SPENT",
                    "TARGET_SPENT/TARGET_SPENT":"TARGET/TARGET_SPENT",

                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("xBetIdle", "spine/ph_spine/x_bet.json"),
                    new SpineAsset("big_win_lvl_1", "spine/ph_spine/big_win_lvl_1.json"),
                    new SpineAsset("big_win_lvl_2", "spine/ph_spine/big_win_lvl_2.json"),
                    new SpineAsset("big_win_lvl_3", "spine/ph_spine/bigwin_lvl_3.json"),
                    new SpineAsset("mainBackgroundAnimation", "spine/ph_spine/mainBG.json"),
                    new SpineAsset("winAttention", "spine/ph_spine/winAttention.json"),
                    new SpineAsset("freespinBackgroundAnimation", "spine/ph_spine/cockpit.json"),
                    new SpineAsset("win_animations", "spine/ph_spine/win_animations.json"),
                    new SpineAsset("win_animations_h", "spine/ph_spine/win_animations_h.json"),
                    new SpineAsset("win_animations1x2", "spine/ph_spine/win_animations_1x2.json"),
                    new SpineAsset("win_animations2x1", "spine/ph_spine/win_animations_2x1.json"),
                    new SpineAsset("win_animations2x2", "spine/ph_spine/win_animations_2x2.json"),
                    new SpineAsset("win_animations1x3", "spine/ph_spine/win_animations_1x3.json"),
                    new SpineAsset("win_animations3x1", "spine/ph_spine/win_animations_3x1.json"),
                    new SpineAsset("win_animations3x3", "spine/ph_spine/win_animations_3x3.json"),
                    new SpineAsset("total_win", "spine/ph_spine/total_win.json"),
                    new SpineAsset("x_bomb", "spine/ph_spine/x_bomb.json"),
                    new SpineAsset("x_bomb_h", "spine/ph_spine/x_bomb_h.json"),
                    new SpineAsset("scatter", "spine/ph_spine/scatter.json"),
                    new SpineAsset("scatter_h", "spine/ph_spine/scatter_h.json"),
                    new SpineAsset("XS", "spine/ph_spine/xs.json"),
                    new SpineAsset("XS_H", "spine/ph_spine/xs_h.json"),
                    new SpineAsset("sword_sweep", "spine/ph_spine/sword_sweep.json"),
                    new SpineAsset("meter", "spine/ph_spine/meter4.json"),
                    new SpineAsset("sfsMeter", "spine/ph_spine/meter5.json"),
                    new SpineAsset("target", "spine/ph_spine/target.json"),
                    new SpineAsset("target_h", "spine/ph_spine/target_h.json"),
                    new SpineAsset("bombAttack0", "spine/ph_spine/outcome_bomb.json"),
                    new SpineAsset("bombAttack1", "spine/ph_spine/outcome_bomb2.json"),
                    new SpineAsset("bombAttack2", "spine/ph_spine/outcome_bomb3.json"),
                    new SpineAsset("capWin", "spine/ph_spine/capWin.json"),
                    new SpineAsset("FSOutro", "spine/ph_spine/FSOutroPearlHarbour.json"),
                    new SpineAsset("kamakazi", "spine/ph_spine/kamikaze_outcomes.json"),
                    new SpineAsset("fsAdd", "spine/ph_spine/add_to_total_effects.json"),
                    new SpineAsset("FSIntroPearlHarbour", "spine/ph_spine/FSIntroPearlHarbour.json"),
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (symbolName[4] === "x") {
            return `${symbolName[0]}${symbolName[1]}/${symbolName.concat().slice(0,6)}`;
        }

        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }

        return symbolName + "/" + symbolName + "" + stateName;
    }
}